var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 186.712,
    height: 166.258,
    viewBox: "0 0 186.712 166.258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#fff;}.b{clip-path:url(#a);}.c{clip-path:url(#b);}.d{clip-path:url(#c);}.e{clip-path:url(#d);}.f{clip-path:url(#e);}.g{clip-path:url(#f);}.h{clip-path:url(#g);}.i{clip-path:url(#h);}.j{clip-path:url(#i);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M79.618,50.893A3.455,3.455,0,1,0,83.063,47.7a3.325,3.325,0,0,0-3.445,3.194",
    transform: "translate(-79.618 -47.699)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M70.4,60.059a3.7,3.7,0,1,0,3.7-3.7,3.7,3.7,0,0,0-3.7,3.7",
    transform: "translate(-70.395 -56.362)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M79.979,68.479a3.2,3.2,0,1,0,3.2-3.191,3.2,3.2,0,0,0-3.2,3.191",
    transform: "translate(-79.979 -65.288)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M88.561,59.525a3.518,3.518,0,1,0,3.509-3.256,3.388,3.388,0,0,0-3.509,3.256",
    transform: "translate(-88.561 -56.269)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M100.762,72.709h10.06a11.22,11.22,0,0,1,7.91,19.15,10.781,10.781,0,0,1-7.91,3.282h-10.06ZM97.22,69.167v38.961h3.542V98.682h10.06a14.979,14.979,0,0,0,4.487-.661l5.148,10.106h3.966l-5.9-11.569a15.982,15.982,0,0,0,2.738-2.221,14.758,14.758,0,0,0-10.435-25.171H97.22Z",
    transform: "translate(-97.22 -69.167)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M144.208,75.3l-8.927,12.326L126.309,75.3h-4.393L133.06,90.644l-11.144,15.35h4.393l8.972-12.326,8.927,12.326H148.6l-11.146-15.35L148.6,75.3Z",
    transform: "translate(-121.916 -75.297)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M189.809,69.167l-17.05,23.707L155.616,69.167h-2.928v38.961h3.542V76.062L171.2,96.794h3.117L189.29,75.967v32.161h3.542V69.167Z",
    transform: "translate(-152.688 -69.167)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M195.061,100.136a13.007,13.007,0,0,1,18.4-18.4,13.848,13.848,0,0,1,2.6,3.683V96.476a13.119,13.119,0,0,1-2.6,3.636,12.994,12.994,0,0,1-18.4.024m-2.5-20.875a16.529,16.529,0,0,0,11.688,28.218,16.124,16.124,0,0,0,11.808-4.96V106.3H219.6V75.555h-3.542V79.38a16.129,16.129,0,0,0-11.808-4.96,15.928,15.928,0,0,0-11.688,4.841",
    transform: "translate(-187.717 -74.42)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M238.207,75.3l-8.925,12.326L220.308,75.3h-4.393l11.146,15.347-11.146,15.35h4.393l8.974-12.326,8.925,12.326H242.6l-11.144-15.35L242.6,75.3Z",
    transform: "translate(-215.915 -75.297)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-96.294 3.037)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.557 -2.537)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.411 38.068)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.889,
    height: 6.387,
    transform: "translate(0 0.001)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.976 49.748)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.394,
    height: 7.394
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.897 61.782)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.403,
    height: 6.385
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.363,107.693a11.3,11.3,0,0,1-2.378-.976c-3.291-1.812-12.235-7.68-12.862-18.3A16.437,16.437,0,0,1,5.754,76.082L27.018,53.948,4.135,31.5a11.5,11.5,0,0,1-2.314-3.22C-.044,24.395-2.466,15.89,5.919,7.135,10.294,2.563,15.709,0,21.346,0,26.5,0,31.838,2.142,36.734,6.862c.381.369.729.787,1.092,1.212L53.958,23.7l3.134,3.048s3.169,2.332-2.239,5.97L34.215,53.783,54.4,72.458A21.4,21.4,0,0,0,56.29,74.02c1.492,1.089,4.438,3.687,2.082,5.752L37.826,100.835s-6.491,7.574-16.268,7.573A19.475,19.475,0,0,1,16.363,107.693ZM30.1,57.646,10.268,77.476s-9.074,9.745,0,20.5c0,0,4.965,5.369,11.918,5.369,3.111,0,6.622-1.078,10.264-4.2L53.372,78.568,30.766,57.14ZM14.049,6.057c-13.158,7.624-8.6,18.5-6.293,22.485a10.532,10.532,0,0,0,1.879,2.381L30.683,50.841,52.7,28.742,33.036,10.257A15.271,15.271,0,0,0,21.11,4.552,17.3,17.3,0,0,0,14.049,6.057Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.468 49.623)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.016,
    height: 6.511,
    transform: "translate(0 0)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.294 123.079)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 28.336,
    height: 38.961
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.296 8.265)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 26.683,
    height: 30.697,
    transform: "translate(0 0.001)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.783 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40.144,
    height: 38.961
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(122.011 7.082)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 31.879,
    height: 33.06,
    transform: "translate(0 0.001)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.028 8.265)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 26.684,
    height: 30.697,
    transform: "translate(0 0.001)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8635c1dbbd16ce0776439d82c6e3916a.svg";
export { ForwardRef as ReactComponent };